import React from 'react';
import type { HilPresentationAction } from '@bizfirst/hil-types';
import { HilActionBar } from '../actions/HilActionBar';

interface InfoStepRendererProps {
  promptMessage: string | null;
  summaryText: string | null;
  actions: HilPresentationAction[];
  disabled?: boolean;
  onAction: (action: HilPresentationAction) => void;
}

export function InfoStepRenderer({
  promptMessage,
  summaryText,
  actions,
  disabled,
  onAction,
}: InfoStepRendererProps): React.JSX.Element {
  return (
    <div className="hil-step-content">
      {promptMessage && <p className="hil-prompt">{promptMessage}</p>}
      {summaryText && (
        <div className="hil-info-block">
          <p>{summaryText}</p>
        </div>
      )}
      {actions.length > 0 && (
        <HilActionBar actions={actions} onAction={onAction} disabled={disabled} />
      )}
    </div>
  );
}
